import { RequestStatus } from "@/api/Requests";

const pending = () => {
  return `
	<svg xmlns="http://www.w3.org/2000/svg" height="23" width="23" viewBox="0 0 412 612" data-cy="icon-request-pending">
		<!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.-->
		<path opacity="1" fill="#28ac19" transform="translate(0, 80)" d="M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 19-5.6 37.4-16 53H112c-10.3-15.6-16-34-16-53zm16 309c3.5-5.3 7.6-10.3 12.1-14.9L192 301.3l67.9 67.9c4.6 4.6 8.6 9.6 12.1 14.9H112z"/>
	</svg>
	`;
};

const inProgress = () => {
  return `
  	<?xml version="1.0" encoding="utf-8"?>
	<!-- Generator: Adobe Illustrator 24.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
	<svg version="1.1" id="Layer_1" 
		xmlns="http://www.w3.org/2000/svg" 
		xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve" class="icon-request-in-progress">
		<style type="text/css">
		.icon-request-in-progress .st0{fill:#FFFFFF;}
		.icon-request-in-progress .st1{fill:none;stroke:#28AC19;stroke-miterlimit:10;}
		.icon-request-in-progress .st2{fill:none;stroke:#28AC19;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
		.icon-request-in-progress .st3{fill:#28AC19;}
		.icon-request-in-progress .st4{fill:none;stroke:#28AC19;stroke-linecap:round;stroke-miterlimit:10;}
		</style>
		<circle class="st0" cx="30" cy="30" r="30"/>
		<g>
			<circle class="st1" cx="30" cy="30" r="23.33"/>
			<polyline class="st2" points="45.32,16.15 30,30 21.98,21.98 	"/>
			<path class="st3" d="M48.17,25.1l5.32,3.72l3.72-5.32c0.37-0.53-0.08-1.25-0.72-1.13l-8.02,1.42C47.82,23.9,47.63,24.73,48.17,25.1
			z"/>
			<path class="st3" d="M11.83,34.9l-5.32-3.72L2.8,36.5c-0.37,0.53,0.08,1.25,0.72,1.13l8.02-1.42C12.18,36.1,12.37,35.27,11.83,34.9
			z"/>
			<g>
				<line class="st4" x1="30" y1="9.58" x2="30" y2="12.5"/>
				<line class="st4" x1="30" y1="47.5" x2="30" y2="50.42"/>
				<line class="st4" x1="19.8" y1="12.32" x2="21.25" y2="14.85"/>
				<line class="st4" x1="38.75" y1="45.15" x2="40.2" y2="47.68"/>
				<line class="st4" x1="12.32" y1="19.78" x2="14.85" y2="21.25"/>
				<line class="st4" x1="45.15" y1="38.75" x2="47.68" y2="40.22"/>
				<line class="st4" x1="9.58" y1="30" x2="12.5" y2="30"/>
				<line class="st4" x1="47.5" y1="30" x2="50.42" y2="30"/>
				<line class="st4" x1="12.32" y1="40.2" x2="14.85" y2="38.75"/>
				<line class="st4" x1="45.15" y1="21.25" x2="47.68" y2="19.8"/>
				<line class="st4" x1="19.78" y1="47.68" x2="21.25" y2="45.15"/>
				<line class="st4" x1="38.75" y1="14.85" x2="40.22" y2="12.32"/>
			</g>
		</g>
	</svg>
  	`;
};

const inProgressAssigned = () => {
  return `
	<?xml version="1.0" encoding="utf-8"?>
	<!-- Generator: Adobe Illustrator 24.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
	<svg version="1.1" id="Layer_1" 
		xmlns="http://www.w3.org/2000/svg" 
		xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve" class="icon-request-in-progress-assigned">
		<style type="text/css">
		.icon-request-in-progress-assigned .st0{fill:#FFFFFF;}
		.icon-request-in-progress-assigned .st1{fill:none;stroke:#28AC19;stroke-miterlimit:10;}
		.icon-request-in-progress-assigned .st2{fill:none;stroke:#28AC19;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
		.icon-request-in-progress-assigned .st3{fill:#28AC19;}
		.icon-request-in-progress-assigned .st4{fill:none;stroke:#28AC19;stroke-linecap:round;stroke-miterlimit:10;}
		</style>
		<circle class="st0" cx="30" cy="30" r="30"/>
		<g>
			<circle class="st1" cx="30" cy="30" r="23.33"/>
			<polyline class="st2" points="45.32,16.15 30,30 21.98,21.98 	"/>
			<path class="st3" d="M48.17,25.1l5.32,3.72l3.72-5.32c0.37-0.53-0.08-1.25-0.72-1.13l-8.02,1.42C47.82,23.9,47.63,24.73,48.17,25.1
			z"/>
			<path class="st3" d="M11.83,34.9l-5.32-3.72L2.8,36.5c-0.37,0.53,0.08,1.25,0.72,1.13l8.02-1.42C12.18,36.1,12.37,35.27,11.83,34.9
			z"/>
			<g>
				<line class="st4" x1="30" y1="9.58" x2="30" y2="12.5"/>
				<line class="st4" x1="30" y1="47.5" x2="30" y2="50.42"/>
				<line class="st4" x1="19.8" y1="12.32" x2="21.25" y2="14.85"/>
				<line class="st4" x1="38.75" y1="45.15" x2="40.2" y2="47.68"/>
				<line class="st4" x1="12.32" y1="19.78" x2="14.85" y2="21.25"/>
				<line class="st4" x1="45.15" y1="38.75" x2="47.68" y2="40.22"/>
				<line class="st4" x1="9.58" y1="30" x2="12.5" y2="30"/>
				<line class="st4" x1="47.5" y1="30" x2="50.42" y2="30"/>
				<line class="st4" x1="12.32" y1="40.2" x2="14.85" y2="38.75"/>
				<line class="st4" x1="45.15" y1="21.25" x2="47.68" y2="19.8"/>
				<line class="st4" x1="19.78" y1="47.68" x2="21.25" y2="45.15"/>
				<line class="st4" x1="38.75" y1="14.85" x2="40.22" y2="12.32"/>
			</g>
		</g>
	</svg>
  	`;
};

const inProgressWithErrors = () => {
  return `
  	<?xml version="1.0" encoding="utf-8"?>
	<!-- Generator: Adobe Illustrator 24.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
	<svg version="1.1" id="Layer_1" 
		xmlns="http://www.w3.org/2000/svg" 
		xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve" class="icon-request-in-progress-with-error">
		<style type="text/css">
		.icon-request-in-progress-with-error .st0{fill:#FFFFFF;}
		.icon-request-in-progress-with-error .st1{fill:none;stroke:#FFD400;stroke-miterlimit:10;}
		.icon-request-in-progress-with-error .st2{fill:none;stroke:#FFD400;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
		.icon-request-in-progress-with-error .st3{fill:#FFD400;}
		.icon-request-in-progress-with-error .st4{fill:none;stroke:#FFD400;stroke-linecap:round;stroke-miterlimit:10;}
		.icon-request-in-progress-with-error .st5{fill:#B21212;}
		.icon-request-in-progress-with-error .st6{font-family:'HelveticaNeue-Bold';}
		.icon-request-in-progress-with-error .st7{font-size:9.25px;}
		</style>
		<circle class="st0" cx="30" cy="30" r="30"/>
		<g>
			<circle class="st1" cx="30" cy="30" r="23.3"/>
			<polyline class="st2" points="45.3,16.1 30,30 22,22 	"/>
			<path class="st3" d="M48.2,25.1l5.3,3.7l3.7-5.3c0.4-0.5-0.1-1.2-0.7-1.1l-8,1.4C47.8,23.9,47.6,24.7,48.2,25.1z"/>
			<path class="st3" d="M11.8,34.9l-5.3-3.7l-3.7,5.3c-0.4,0.5,0.1,1.2,0.7,1.1l8-1.4C12.2,36.1,12.4,35.3,11.8,34.9z"/>
			<g>
				<line class="st4" x1="30" y1="9.6" x2="30" y2="12.5"/>
				<line class="st4" x1="30" y1="47.5" x2="30" y2="50.4"/>
				<line class="st4" x1="19.8" y1="12.3" x2="21.2" y2="14.9"/>
				<line class="st4" x1="38.8" y1="45.2" x2="40.2" y2="47.7"/>
				<line class="st4" x1="12.3" y1="19.8" x2="14.9" y2="21.2"/>
				<line class="st4" x1="45.2" y1="38.8" x2="47.7" y2="40.2"/>
				<line class="st4" x1="9.6" y1="30" x2="12.5" y2="30"/>
				<line class="st4" x1="47.5" y1="30" x2="50.4" y2="30"/>
				<line class="st4" x1="12.3" y1="40.2" x2="14.9" y2="38.8"/>
				<line class="st4" x1="45.2" y1="21.2" x2="47.7" y2="19.8"/>
				<line class="st4" x1="19.8" y1="47.7" x2="21.2" y2="45.2"/>
				<line class="st4" x1="38.8" y1="14.9" x2="40.2" y2="12.3"/>
			</g>
		</g>	
	</svg>
	`;
};

const complete = () => {
  return `
  	<?xml version="1.0" encoding="utf-8"?>
	<!-- Generator: Adobe Illustrator 24.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
	<svg version="1.1" id="Layer_1" 
		xmlns="http://www.w3.org/2000/svg" 
		xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve" class="icon-request-complete">
		<style type="text/css">
		.icon-request-complete .st0{fill:#FFFFFF;}
		.icon-request-complete .st1{fill:#28AC19;}
		</style>
		<circle class="st0" cx="30" cy="30" r="30"/>
		<g>
			<path class="st1" d="M8.68,40.52l14.77,16.43c0.67,0.75,1.85,0.73,2.5-0.02l30.68-35.42c0.55-0.65,0.53-1.6-0.03-2.22l-4.57-4.93
			c-0.7-0.75-1.9-0.7-2.53,0.1L24.83,45.78c-0.33,0.43-1,0.42-1.32-0.02l-8.33-11.22c-0.6-0.82-1.78-0.9-2.52-0.2l-3.92,3.88
			C8.12,38.85,8.1,39.87,8.68,40.52z"/>
		</g>
	</svg>
`;
};

const completeWithErrors = () => {
  return `
  <?xml version="1.0" encoding="utf-8"?>
  <!-- Generator: Adobe Illustrator 24.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
  <svg version="1.1" id="Layer_1" 
     xmlns="http://www.w3.org/2000/svg" 
     xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve" class="icon-request-complete-with-error">
     <style type="text/css">
     .icon-request-complete-with-error .st0{fill:#FFFFFF;}
     .icon-request-complete-with-error .st1{fill:#FF8C1A;}
     .icon-request-complete-with-error .st2{fill:#B21212;}
     .icon-request-complete-with-error .st3{font-family:'HelveticaNeue-Bold';}
     .icon-request-complete-with-error .st4{font-size:9.25px;}
     </style>
     <circle class="st0" cx="30" cy="30" r="30"/>
     <g>
        <path class="st1" d="M8.68,40.52l14.77,16.43c0.67,0.75,1.85,0.73,2.5-0.02l30.68-35.42c0.55-0.65,0.53-1.6-0.03-2.22l-4.57-4.93
        c-0.7-0.75-1.9-0.7-2.53,0.1L24.83,45.78c-0.33,0.43-1,0.42-1.32-0.02l-8.33-11.22c-0.6-0.82-1.78-0.9-2.52-0.2l-3.92,3.88
        C8.12,38.85,8.1,39.87,8.68,40.52z"/>
     </g>     
  </svg>
    `;
};

const cancelled = () => {
  return `
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-request-cancelled">
		<path d="M17.5 1.25C18.8672 1.25 20 2.38281 20 3.75V16.25C20 17.6562 18.8672 18.75 17.5 18.75H2.5C1.09375 18.75 0 17.6562 0 16.25V3.75C0 2.38281 1.09375 1.25 2.5 1.25H17.5ZM6.83594 8.16406L8.67188 10L6.83594 11.8359C6.44531 12.2266 6.44531 12.8125 6.83594 13.1641C7.1875 13.5547 7.77344 13.5547 8.125 13.1641L9.96094 11.3281L11.8359 13.1641C12.1875 13.5547 12.7734 13.5547 13.125 13.1641C13.5156 12.8125 13.5156 12.2266 13.125 11.8359L11.2891 10L13.125 8.16406C13.5156 7.8125 13.5156 7.22656 13.125 6.83594C12.7734 6.48438 12.1875 6.48438 11.8359 6.83594L9.96094 8.71094L8.125 6.83594C7.77344 6.48438 7.1875 6.48438 6.83594 6.83594C6.44531 7.22656 6.44531 7.8125 6.83594 8.16406Z" fill="gray"/>
	</svg>
	`;
};

export const requestIcon = (status: RequestStatus) => {
  switch (status) {
    case RequestStatus.Pending:
      return pending();
    case RequestStatus.InProgress:
      return inProgress();
    case RequestStatus.InProgressAssigned:
      return inProgressAssigned();
    case RequestStatus.InProgressWithErrors:
      return inProgressWithErrors();
    case RequestStatus.Complete:
      return complete();
    case RequestStatus.CompleteWithErrors:
      return completeWithErrors();
    case RequestStatus.Cancelled:
      return cancelled();
    default:
      return pending();
  }
};
